import React from 'react';
import {
  Button,
  Col,
  Container,
  Alert,
  //Nav,
  //Navbar,
  Row,
  Form,
  //Input,
  Stack
} from 'react-bootstrap';
import CircularProgress from '@mui/material/CircularProgress';

export default function LoadingSpinner() {
    return (
          <Container fluid>            
            <Row style={{ marginTop: "15px", marginBottom: "15px" }}> 
                <div className="d-flex align-items-center justify-content-center">
                  <CircularProgress />
                </div>            
              {/* <Col md="5"></Col> */}
              {/* <Col md="5"></Col> */}
            </Row>
          </Container>
    )
  }
